'use client';

import { createContext, useContext, useState } from 'react';

const AuthContext = createContext<any>({});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

// Mock user — matches the demo Investment User account used throughout the app
const MOCK_USER = {
  id: 'mock-user-001',
  email: 'j.rothbury@meridiancap.com',
  email_confirmed_at: new Date().toISOString(),
  user_metadata: {
    full_name: 'James Rothbury',
    avatar_url: '',
  },
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<any>(MOCK_USER);
  const [session, setSession] = useState<any>({ user: MOCK_USER });
  const [loading] = useState(false);

  // Mock Sign Up — no-op in demo mode
  const signUp = async (_email: string, _password: string, _metadata = {}) => {
    return { user: MOCK_USER, session: null };
  };

  // Mock Sign In — validates against demo accounts
  const signIn = async (email: string, _password: string) => {
    const mockSession = { user: { ...MOCK_USER, email } };
    setUser({ ...MOCK_USER, email });
    setSession(mockSession);
    return { user: { ...MOCK_USER, email }, session: mockSession };
  };

  // Mock Sign Out
  const signOut = async () => {
    setUser(null);
    setSession(null);
  };

  // Get Current User
  const getCurrentUser = async () => {
    return user;
  };

  // Check if Email is Verified
  const isEmailVerified = () => {
    return true;
  };

  // Get User Profile from mock data
  const getUserProfile = async () => {
    if (!user) return null;
    return {
      id: user.id,
      email: user.email,
      full_name: user.user_metadata?.full_name ?? '',
      job_title: 'Managing Director',
      firm_id: 'firm-004',
    };
  };

  const value = {
    user,
    session,
    loading,
    signUp,
    signIn,
    signOut,
    getCurrentUser,
    isEmailVerified,
    getUserProfile,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
